import {createContext} from 'react';

export interface VisaErrorOptions {
  secondaryLabel?: string;
  onSecondaryClick?: () => void;
  hideSecondary?: boolean;
  onDismiss?: () => void;
}

interface AlertContextType {
  success: (message: string, onClick: () => void) => void;
  error: (message: string) => void;
  confirm: (message: string, onConfirm: () => void) => void;
  visaError: (
    message: string,
    description: string,
    onClick: () => void,
    options?: VisaErrorOptions,
  ) => void;
  passportError: (
    errorType: string,
    fields: string[],
    errors?: string[],
    options?: VisaErrorOptions,
  ) => void;
  passportNumberError: (
    message: string,
    description: string,
    onClick: () => void,
    options?: VisaErrorOptions,
  ) => void;
  tenantAdditionalError: (
    message: string,
    description: string,
    onClick: () => void,
  ) => void;
  tenantEditDetailError: (
    message: string,
    data: Record<string, any>,
    onClick: () => void,
  ) => void;
  tenantStatementError: (
    message: string,
    description: string,
    onClick: () => void,
  ) => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export default AlertContext;
